import { List, ListItem, ListItemText, Divider, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { MESSAGES } from "../../data";

export default function InboxMessageList() {
  const navigate = useNavigate();

  return (
    <List>
      {MESSAGES.map((msg) => (
        <div key={msg.id}>
          <ListItem button onClick={() => navigate(`/inbox/message/${msg.id}`)}>
            <ListItemText
              primary={
                <Typography fontWeight={msg.unread ? "bold" : "normal"}>
                  {msg.from} — {msg.subject}
                </Typography>
              }
              secondary={msg.preview}
            />
          </ListItem>
          <Divider />
        </div>
      ))}
    </List>
  );
}